import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useSearchParams } from 'react-router-dom';
import { fetchContents } from '../store/contentSlice';
import { SUBGENRES, SUBGENRE_LABELS } from '../data/catalog';
import ContentGrid from './ContentGrid';

export default function CategoryPage({ type, title }) {
  const [searchParams] = useSearchParams();
  const genre = searchParams.get('genre') || 'all';
  const dispatch = useDispatch();
  const { items, loading } = useSelector((state) => state.content);

  useEffect(() => {
    const params = { limit: 50, type };
    if (genre !== 'all') params.genre = genre;
    dispatch(fetchContents(params));
  }, [dispatch, type, genre]);

  const subgenres = SUBGENRES[type] || [];
  let filtered = items.filter(i => i.type === type);
  if (genre !== 'all') filtered = filtered.filter(i => i.genre === genre);

  return (
    <div className="category-page">
      <h2 className="category-title">{title} <span className="category-genre-label">/ {genre === 'all' ? 'All' : SUBGENRE_LABELS[genre] || genre}</span></h2>
      {subgenres.length > 0 && (
        <>
        <span className="mobile-drawer-nav-label category-sub-label">Choose subgenre</span>
        <div className="category-bar">
          {subgenres.map((g) => (
            <Link
              key={g}
              to={g === 'all' ? `/${type}` : `/${type}?genre=${g}`}
              className={`category-bar-item ${genre === g || (g === 'all' && genre === 'all') ? 'active' : ''}`}
            >
              {SUBGENRE_LABELS[g] || g}
            </Link>
          ))}
        </div>
        </>
      )}
      <ContentGrid items={filtered} loading={loading} />
    </div>
  );
}
